export default __webpack_public_path__ + "static/media/player.adeecbaa.png";